import styles from './InfoPopup.module.css';

const InfoPopup = ({ children, shortInfo }: { children: any; shortInfo?: string }) => {
    return (
        <div className={styles.tip}>
            <button className={styles.tipBtn}>
                {shortInfo && <span>{shortInfo}</span>}
                <span className={styles.tipBtnImg}>
                    <img alt={''} src={'/icons/info.png'} />
                    <img alt={''} src={'/icons/info-active.png'} />
                </span>
            </button>

            <div className={`${styles.tipBox}`}>{children}</div>
        </div>
    );
};

export default InfoPopup;
